// Barre de progression des navigations, pilotée par les événements d'Inertia :
// élément .page-progress-bar, que stylise le layout (2px, #e0bc8a, halo),
// largeur 10 % + valeur × 90 %, avancée toutes les 300 ms, fondu à la fin.
// Affichée sans délai.
import { router } from '@inertiajs/react'

const DURATION = 300

const DEFAULT_CSS = `
.page-progress-bar {
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  height: 3px;
  background: #0076ff;
  z-index: 2147483647;
  transition:
    width ${DURATION}ms ease-out,
    opacity ${DURATION / 2}ms ${DURATION / 2}ms ease-in;
  transform: translate3d(0, 0, 0);
}`

class ProgressBar {
  private stylesheet: HTMLStyleElement
  private element: HTMLDivElement
  private hiding = false
  private visible = false
  private value = 0
  private trickleInterval: number | undefined

  constructor() {
    this.stylesheet = document.createElement('style')
    this.stylesheet.textContent = DEFAULT_CSS
    document.head.insertBefore(this.stylesheet, document.head.firstChild)
    this.element = document.createElement('div')
    this.element.className = 'page-progress-bar'
    this.setValue(0)
  }

  show() {
    if (this.visible) return
    this.visible = true
    this.element.style.width = '0'
    this.element.style.opacity = '1'
    document.documentElement.insertBefore(this.element, document.body)
    this.refresh()
    this.trickleInterval ??= window.setInterval(() => this.setValue(this.value + Math.random() / 100), DURATION)
  }

  hide() {
    if (!this.visible || this.hiding) return
    this.hiding = true
    this.element.style.opacity = '0'
    window.setTimeout(() => {
      this.element.remove()
      window.clearInterval(this.trickleInterval)
      this.trickleInterval = undefined
      this.visible = false
      this.hiding = false
    }, DURATION * 1.5)
  }

  setValue(value: number) {
    this.value = value
    this.refresh()
  }

  private refresh() {
    requestAnimationFrame(() => {
      this.element.style.width = `${10 + this.value * 90}%`
    })
  }
}

export function installProgressBar(): void {
  const bar = new ProgressBar()
  let active = 0

  router.on('start', (event) => {
    const visit = event.detail.visit
    // Visites et soumissions de formulaire seulement, pas les requêtes de
    // fond (polling, préchargement).
    if (visit.async || visit.prefetch) return
    active++
    bar.setValue(0)
    bar.show()
  })

  router.on('finish', (event) => {
    const visit = event.detail.visit
    if (visit.async || visit.prefetch) return
    active = Math.max(0, active - 1)
    if (active > 0) return
    bar.setValue(1)
    bar.hide()
  })
}
